export default __webpack_public_path__ + "static/media/Festival de cine y artes audiovisuales 2026.5b592241.jpg";